import { render } from "./BalLoadingIcon.vue?vue&type=template&id=5c9944f3&scoped=true"
import script from "./BalLoadingIcon.vue?vue&type=script&lang=js"
export * from "./BalLoadingIcon.vue?vue&type=script&lang=js"

import "./BalLoadingIcon.vue?vue&type=style&index=0&id=5c9944f3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c9944f3"

export default script